import React, { useState, useEffect } from "react";
import "./style.css";
import Header from "../../../componente/header";
import Paginacao from "../../../componente/paginacao";
import Impressora from "../../../assets/Impressora.png";
import api from "../../../services/api";
import LoadingScreen from "../../../componente/aguarde";
import { podeImprimir } from "../../../componente/permissoes";

const API_URL = "v1/relatorio";
const AUTOCOMPLETE_URL = "v1/relatorio/filtro";

const RelCliente = () => {
  const [abusca, setabusca] = useState("");
  const [offset, setOffset] = useState(0);
  const [edtcodequipe, setedtcodequipe] = useState(0);
  const [edtcidade, setedtcidade] = useState("0");
  const [lista, setlista] = useState([]);
  const [listaequipe, setlistaequipe] = useState([]);
  const [listacidade, setlistacidade] = useState([]);
  const [qtdetotalpag, setqtdetotalpag] = useState(0);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [inputValue2, setInputValue2] = useState('');

  const handleEquipeSelecionado = (equip) => {
    setInputValue(equip.descricao);
    setedtcodequipe(equip.codequipe);
    setlistaequipe([]);
  };

  const handleCidadeSelecionado = (cid) => {
    setInputValue2(cid.cidade);
    setedtcidade(cid.cidade);
    setlistacidade([]);
  };

  const handleInputChange = async (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.length > 2) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/equipe`, {
          params: { busca: value },
          headers: { Authorization: `Bearer ${localStorage.getItem("tempToken")}` },
        });
        setlistaequipe(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistaequipe([]);
      setedtcodequipe(0);
    }
  };

  const handleInputChange2 = async (e) => {
    const value = e.target.value;
    setInputValue2(value);

    if (value.length > 2) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/cidade`, {
          params: { busca: value },
          headers: { Authorization: `Bearer ${localStorage.getItem("tempToken")}` },
        });
        setlistacidade(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistacidade([]);
      setedtcidade("0");
    }
  };

  const imprimir = async () => {
    setLoading(true);

    try {
      const response = await api.get(`v1/impressoes/relcliente`, {
        responseType: "arraybuffer",
        params: {
          busca: abusca,
          codequipe: edtcodequipe,
          cidade: edtcidade,
          usuario: localStorage.getItem("tempUsuario"),
          codusuario: localStorage.getItem("tempCodUsuario"),
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.click();
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    } finally {
      setLoading(false);
    }
  };

  const fetchListarCliente = async () => {
    try {
      const response = await api.get(`${API_URL}/cliente`, {
        params: {
          busca: abusca,
          offset,
          codequipe: edtcodequipe,
          cidade: edtcidade,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      setlista(response.data);
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    }
  };

  useEffect(() => {
    fetchListarCliente();
  }, [abusca, offset, edtcidade, edtcodequipe]);

  const fetchListarPaginas = async () => {
    try {
      const response = await api.get(`${API_URL}/cliente/pagtotal`, {
        params: {
          busca: abusca,
          codequipe: edtcodequipe,
          cidade: edtcidade,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      setqtdetotalpag(response.data.paginatotal);
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    }
  };

  useEffect(() => {
    fetchListarPaginas();
  }, [lista]);

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <h1 className="ms-4">Relatório de Cliente</h1>
          <p className="ms-4">
            Rotina para listar todos os clientes, com a opção de filtrar por
            cidade e equipe.
          </p>
          <hr />
        </div>

        <div className="row">
          <div className="col-sm-5">
            <label className="form-label" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código, nome ou cpf"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => {
                setabusca(e.target.value);
                setOffset(0);
              }}
            />
          </div>

          <div className="col-sm-3">
            <label htmlFor="equipe" className="form-label">
              Equipe
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue}
              onChange={handleInputChange}
            />
            <ul className="autocomplete-list">
              {listaequipe.map((equipe) => (
                <li
                  key={equipe.codequipe}
                  onClick={() => handleEquipeSelecionado(equipe)}
                >
                  {equipe.descricao}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-sm-3">
            <label htmlFor="cidade" className="form-label">
              Cidade
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue2}
              onChange={handleInputChange2}
            />
            <ul className="autocomplete-list">
              {listacidade.map((cid) => (
                <li
                  key={cid.cidade}
                  onClick={() => handleCidadeSelecionado(cid)}
                >
                  {cid.cidade}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-sm-1 d-flex justify-content-center">
            <button className="btn" onClick={imprimir} disabled={!podeImprimir("/relatorio/cliente")}>
              <img src={Impressora} alt="Imprimir" />
              <label>Imprimir</label>
            </button>
            {loading && <LoadingScreen />}
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row tabela">
          <table className="col-sm-12 table table-hover">
            <thead>
              <tr>
                <th className="codigo">Código</th>
                <th className="razao">Nome</th>
                <th className="cidade">Cidade</th>
                <th className="equipe">Equipe</th>
                <th className="cpf">CPF</th>
                <th className="whatsapp">WhatsApp</th>
              </tr>
            </thead>
            <tbody>
              {lista.map((item) => (
                <tr key={item.codcliente}>
                  <th>{item.codcliente}</th>
                  <th>{item.nome}</th>
                  <th>{item.cidade}</th>
                  <th>{item.equipe}</th>
                  <th>{item.cpf}</th>
                  <th>{item.whatsapp}</th>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row d-flex justify-content-center">
          <Paginacao
            limit={20}
            total={qtdetotalpag}
            offset={offset}
            setOffset={setOffset}
          />
        </div>
      </div>
    </>
  );
};

export default RelCliente;
